import { ABS } from 'containers/Manual/project/compute/functions/abs';
import { AND } from 'containers/Manual/project/compute/functions/and';
import { AVERAGE } from 'containers/Manual/project/compute/functions/average';
import { CEILING } from 'containers/Manual/project/compute/functions/ceiling';
import { CHAR } from 'containers/Manual/project/compute/functions/char';
import { CONCATENATE } from 'containers/Manual/project/compute/functions/concatenate';
import { DATE } from 'containers/Manual/project/compute/functions/date';
import { DATEADD } from 'containers/Manual/project/compute/functions/dateAdd';
import { DATEDIFF } from 'containers/Manual/project/compute/functions/dateDiff';
import { DATEFORMAT } from 'containers/Manual/project/compute/functions/dateFormat';
import { DATETRUNC } from 'containers/Manual/project/compute/functions/datetrunc';
import { DATEVALUE } from 'containers/Manual/project/compute/functions/dateValue';
import { DAY } from 'containers/Manual/project/compute/functions/day';
import { DAYOFWEEK } from 'containers/Manual/project/compute/functions/dayOfWeek';
import { DAYOFYEAR } from 'containers/Manual/project/compute/functions/dayOfYear';
import { ENDOFMONTH } from 'containers/Manual/project/compute/functions/endOfMonth';
import { EXP } from 'containers/Manual/project/compute/functions/exp';
import { FACTORIAL } from 'containers/Manual/project/compute/functions/factorial';
import { FIND } from 'containers/Manual/project/compute/functions/find';
import { FIRSTNONBLANK } from 'containers/Manual/project/compute/functions/firstNonBlank';
import { FLOOR } from 'containers/Manual/project/compute/functions/floor';
import { FROMUNIXTIME } from 'containers/Manual/project/compute/functions/fromUnixTime';
import { HASHVALUE } from 'containers/Manual/project/compute/functions/hashvalue';
import { HOUR } from 'containers/Manual/project/compute/functions/hour';
import { IF } from 'containers/Manual/project/compute/functions/if';
import { IFERROR } from 'containers/Manual/project/compute/functions/ifError';
import { INT } from 'containers/Manual/project/compute/functions/int';
import { ISBLANK } from 'containers/Manual/project/compute/functions/isBlank';
import { ISDATE } from 'containers/Manual/project/compute/functions/isDate';
import { ISNULL } from 'containers/Manual/project/compute/functions/isNull';
import { ISNUMBER } from 'containers/Manual/project/compute/functions/isNumber';
import { ISTEXT } from 'containers/Manual/project/compute/functions/isText';
import { LEFT } from 'containers/Manual/project/compute/functions/left';
import { LEN } from 'containers/Manual/project/compute/functions/len';
import { LN } from 'containers/Manual/project/compute/functions/ln';
import { LOG } from 'containers/Manual/project/compute/functions/log';
import { LOG10 } from 'containers/Manual/project/compute/functions/log10';
import { LOWER } from 'containers/Manual/project/compute/functions/lower';
import { MAX } from 'containers/Manual/project/compute/functions/max';
import { MAXDATE } from 'containers/Manual/project/compute/functions/maxDate';
import { MEDIAN } from 'containers/Manual/project/compute/functions/median';
import { MID } from 'containers/Manual/project/compute/functions/mid';
import { MIDNIGHT } from 'containers/Manual/project/compute/functions/midNight';
import { MIN } from 'containers/Manual/project/compute/functions/min';
import { MINDATE } from 'containers/Manual/project/compute/functions/minDate';
import { MINUTE } from 'containers/Manual/project/compute/functions/minute';
import { MOD } from 'containers/Manual/project/compute/functions/mod';
import { MODE } from 'containers/Manual/project/compute/functions/mode';
import { MONTH } from 'containers/Manual/project/compute/functions/month';
import { NETWORKDAYS } from 'containers/Manual/project/compute/functions/networkDays';
import { NOT } from 'containers/Manual/project/compute/functions/not';
import { NOW } from 'containers/Manual/project/compute/functions/now';
import { OR } from 'containers/Manual/project/compute/functions/or';
import { PADLEFT } from 'containers/Manual/project/compute/functions/padleft';
import { PADRIGHT } from 'containers/Manual/project/compute/functions/padright';
import { POWER } from 'containers/Manual/project/compute/functions/power';
import { QUARTER } from 'containers/Manual/project/compute/functions/quarter';
import { REGEXP } from 'containers/Manual/project/compute/functions/regexp';
import { REPEAT } from 'containers/Manual/project/compute/functions/repeat';
import { REPLACE } from 'containers/Manual/project/compute/functions/replace';
import { REVERSE } from 'containers/Manual/project/compute/functions/reverse';
import { RIGHT } from 'containers/Manual/project/compute/functions/right';
import { ROUND } from 'containers/Manual/project/compute/functions/round';
import { ROUNDDOWN } from 'containers/Manual/project/compute/functions/rounddown';
import { ROUNDPERC } from 'containers/Manual/project/compute/functions/roundperc';
import { SEARCH } from 'containers/Manual/project/compute/functions/search';
import { SECOND } from 'containers/Manual/project/compute/functions/second';
import { SETTIMEZONE } from 'containers/Manual/project/compute/functions/setTimeZone';
import { SIGN } from 'containers/Manual/project/compute/functions/sign';
import { SQRT } from 'containers/Manual/project/compute/functions/sqrt';
import { STDEV } from 'containers/Manual/project/compute/functions/stdev';
import { STDEVP } from 'containers/Manual/project/compute/functions/stdevp';
import { STR } from 'containers/Manual/project/compute/functions/str';
import { SUBSTITUTE } from 'containers/Manual/project/compute/functions/substitute';
import { SUM } from 'containers/Manual/project/compute/functions/sum';
import { TODAY } from 'containers/Manual/project/compute/functions/today';
import { TRIM } from 'containers/Manual/project/compute/functions/trim';
import { TRIMLEFT } from 'containers/Manual/project/compute/functions/trimleft';
import { TRIMRIGHT } from 'containers/Manual/project/compute/functions/trimright';
import { UPPER } from 'containers/Manual/project/compute/functions/upper';
import { VALUE } from 'containers/Manual/project/compute/functions/value';
import { VAR } from 'containers/Manual/project/compute/functions/var';
import { VARP } from 'containers/Manual/project/compute/functions/varp';
import { WEEKOFYEAR } from 'containers/Manual/project/compute/functions/weekOfYear';
import { WORKDAY } from 'containers/Manual/project/compute/functions/workDay';
import { YEAR } from 'containers/Manual/project/compute/functions/year';

import { DropDownListOptionType, ThemeColorType } from 'types/common/CommonType';
import {
  ConnectorAbleOptionType,
  ConnectorBooleanOptionType,
  ConnectorJdbcOptionInfoType,
  ConnectorSftpOptionInfoType,
  ConnectorValueType,
  ConnectorVisibleOptionType,
  DatasourceJdbcOptionInfoType,
  DatasourceSftpOptionInfoType,
  DropdownConnectorType,
} from 'types/connectorAndDatasource/ConnectorAndDatasourceType';
import { LibraryExportFileDtoType } from 'types/library/LibraryExportType';
import {
  LibraryFileDtoDefaultType,
  LibraryImportPreviewFileDtoType,
} from 'types/library/LibraryImportType';
import { LibraryFileFormatKeySmallType, LibraryFileFormatKeyType } from 'types/library/LibraryType';
import { getTranslation } from 'utils/translation';
export const GLOBAL_MENU_LIST = ['Library', 'Project', 'Admin'];

export const DAY_IN_MILLISECONDS = 24 * 60 * 60 * 1000;
export const YEAR_IN_MILLISECONDS = 24 * 60 * 60 * 1000 * 365;

export interface NavMenuProps {
  key: string; // 메뉴의 고유 키
  title: string; // 메뉴 제목
  path?: string; // 메뉴 경로 (optional)
  icon?: React.JSX.Element; // 메뉴 아이콘 (React 컴포넌트)
  children?: NavSubMenuProps[];
}

export interface NavSubMenuProps {
  key: string; // 메뉴의 고유 키
  title: string; // 메뉴 제목
  path: string; // 메뉴 경로 (optional)
  isSuperUser?: boolean; // superuser 계정만 출력되는 메뉴 여부 (임시)
}

export interface TypeListProps {
  label: string; // 보여질값
  value: string; // 실제값
}

export const FILE_FORMAT_MAP: { [key: string]: LibraryFileFormatKeyType } = {
  csv: 'Delimited',
  txt: 'Fixed',
  xlsx: 'Excel',
  xls: 'Excel',
  json: 'Json',
  avro: 'Avro',
  xml: 'Xml',
};

export const FILE_FORMAT_OPTION_DISABLED_BY_EXT: {
  [key: string]: DropDownListOptionType[];
} = {
  default: [
    {
      get label() {
        return getTranslation('resource', 'AVRO');
      },
      value: 'Avro',
      dbType: 'Avro',
      disabled: true,
    },
    {
      get label() {
        return getTranslation('resource', 'DELIMITED');
      },
      value: 'Delimited',
      dbType: 'Delimited',
      disabled: false,
    },
    {
      get label() {
        return getTranslation('resource', 'EXCEL');
      },
      value: 'Excel',
      dbType: 'Excel',
      disabled: true,
    },
    {
      get label() {
        return getTranslation('resource', 'FIXED_WIDTH');
      },
      value: 'Fixed',
      dbType: 'Fixed Width',
      disabled: false,
    },
    {
      get label() {
        return getTranslation('resource', 'JSON');
      },
      value: 'Json',
      dbType: 'JSON',
      disabled: true,
    },
    {
      get label() {
        return getTranslation('resource', 'XML');
      },
      value: 'Xml',
      dbType: 'XML',
      disabled: true,
    },
  ],

  document: [
    {
      get label() {
        return getTranslation('resource', 'AVRO');
      },
      value: 'Avro',
      dbType: 'Avro',
      disabled: true,
    },
    {
      get label() {
        return getTranslation('resource', 'DELIMITED');
      },
      value: 'Delimited',
      dbType: 'Delimited',
      disabled: false,
    },
    {
      get label() {
        return getTranslation('resource', 'EXCEL');
      },
      value: 'Excel',
      dbType: 'Excel',
      disabled: true,
    },
    {
      get label() {
        return getTranslation('resource', 'FIXED_WIDTH');
      },
      value: 'Fixed',
      dbType: 'Fixed Width',
      disabled: false,
    },
    {
      get label() {
        return getTranslation('resource', 'JSON');
      },
      value: 'Json',
      dbType: 'JSON',
      disabled: true,
    },
    {
      get label() {
        return getTranslation('resource', 'XML');
      },
      value: 'Xml',
      dbType: 'XML',
      disabled: true,
    },
    {
      get label() {
        return 'Document';
      },
      value: 'Document',
      dbType: 'Document',
      disabled: false,
    },
    {
      get label() {
        return 'Ocr';
      },
      value: 'Ocr',
      dbType: 'Ocr',
      disabled: false,
    },
  ],

  xlsx: [
    {
      get label() {
        return getTranslation('resource', 'AVRO');
      },
      value: 'Avro',
      dbType: 'Avro',
      disabled: true,
    },
    {
      get label() {
        return getTranslation('resource', 'DELIMITED');
      },
      value: 'Delimited',
      dbType: 'Delimited',
      disabled: true,
    },
    {
      get label() {
        return getTranslation('resource', 'EXCEL');
      },
      value: 'Excel',
      dbType: 'Excel',
      disabled: false,
    },
    {
      get label() {
        return getTranslation('resource', 'FIXED_WIDTH');
      },
      value: 'Fixed',
      dbType: 'Fixed Width',
      disabled: true,
    },
    {
      get label() {
        return getTranslation('resource', 'JSON');
      },
      value: 'Json',
      dbType: 'JSON',
      disabled: true,
    },
    {
      get label() {
        return getTranslation('resource', 'XML');
      },
      value: 'Xml',
      dbType: 'XML',
      disabled: true,
    },
  ],

  xls: [
    {
      get label() {
        return getTranslation('resource', 'AVRO');
      },
      value: 'Avro',
      dbType: 'Avro',
      disabled: true,
    },
    {
      get label() {
        return getTranslation('resource', 'DELIMITED');
      },
      value: 'Delimited',
      dbType: 'Delimited',
      disabled: true,
    },
    {
      get label() {
        return getTranslation('resource', 'EXCEL');
      },
      value: 'Excel',
      dbType: 'Excel',
      disabled: false,
    },
    {
      get label() {
        return getTranslation('resource', 'FIXED_WIDTH');
      },
      value: 'Fixed',
      dbType: 'Fixed Width',
      disabled: true,
    },
    {
      get label() {
        return getTranslation('resource', 'JSON');
      },
      value: 'Json',
      dbType: 'JSON',
      disabled: true,
    },
    {
      get label() {
        return getTranslation('resource', 'XML');
      },
      value: 'Xml',
      dbType: 'XML',
      disabled: true,
    },
  ],

  avro: [
    {
      get label() {
        return getTranslation('resource', 'AVRO');
      },
      value: 'Avro',
      dbType: 'Avro',
      disabled: false,
    },
    {
      get label() {
        return getTranslation('resource', 'DELIMITED');
      },
      value: 'Delimited',
      dbType: 'Delimited',
      disabled: false,
    },
    {
      get label() {
        return getTranslation('resource', 'EXCEL');
      },
      value: 'Excel',
      dbType: 'Excel',
      disabled: true,
    },
    {
      get label() {
        return getTranslation('resource', 'FIXED_WIDTH');
      },
      value: 'Fixed',
      dbType: 'Fixed Width',
      disabled: false,
    },
    {
      get label() {
        return getTranslation('resource', 'JSON');
      },
      value: 'Json',
      dbType: 'JSON',
      disabled: true,
    },
    {
      get label() {
        return getTranslation('resource', 'XML');
      },
      value: 'Xml',
      dbType: 'XML',
      disabled: true,
    },
  ],

  xml: [
    {
      get label() {
        return getTranslation('resource', 'AVRO');
      },
      value: 'Avro',
      dbType: 'Avro',
      disabled: true,
    },
    {
      get label() {
        return getTranslation('resource', 'DELIMITED');
      },
      value: 'Delimited',
      dbType: 'Delimited',
      disabled: false,
    },
    {
      get label() {
        return getTranslation('resource', 'EXCEL');
      },
      value: 'Excel',
      dbType: 'Excel',
      disabled: true,
    },
    {
      get label() {
        return getTranslation('resource', 'FIXED_WIDTH');
      },
      value: 'Fixed',
      dbType: 'Fixed Width',
      disabled: false,
    },
    {
      get label() {
        return getTranslation('resource', 'JSON');
      },
      value: 'Json',
      dbType: 'JSON',
      disabled: true,
    },
    {
      get label() {
        return getTranslation('resource', 'XML');
      },
      value: 'Xml',
      dbType: 'XML',
      disabled: false,
    },
  ],

  json: [
    {
      get label() {
        return getTranslation('resource', 'AVRO');
      },
      value: 'Avro',
      dbType: 'Avro',
      disabled: true,
    },
    {
      get label() {
        return getTranslation('resource', 'DELIMITED');
      },
      value: 'Delimited',
      dbType: 'Delimited',
      disabled: false,
    },
    {
      get label() {
        return getTranslation('resource', 'EXCEL');
      },
      value: 'Excel',
      dbType: 'Excel',
      disabled: true,
    },
    {
      get label() {
        return getTranslation('resource', 'FIXED_WIDTH');
      },
      value: 'Fixed',
      dbType: 'Fixed Width',
      disabled: false,
    },
    {
      get label() {
        return getTranslation('resource', 'JSON');
      },
      value: 'Json',
      dbType: 'JSON',
      disabled: false,
    },
    {
      get label() {
        return getTranslation('resource', 'XML');
      },
      value: 'Xml',
      dbType: 'XML',
      disabled: true,
    },
  ],
};

export const JDBC_FORMAT_OPTION: DropDownListOptionType[] = [
  { label: getTranslation('resource', 'JDBC'), value: 'Jdbc', dbType: 'JDBC' },
];

export const FILE_FORMAT_OPTION: DropDownListOptionType[] = [
  {
    label: getTranslation('resource', 'AVRO'),
    value: 'Avro',
    dbType: 'Avro',
    disabled: true,
  },
  {
    label: getTranslation('resource', 'DELIMITED'),
    value: 'Delimited',
    dbType: 'Delimited',
  },
  {
    label: getTranslation('resource', 'EXCEL'),
    value: 'Excel',
    dbType: 'Excel',
  },
  {
    label: getTranslation('resource', 'FIXED_WIDTH'),
    value: 'Fixed',
    dbType: 'Fixed Width',
  },
  { label: getTranslation('resource', 'JSON'), value: 'Json', dbType: 'JSON' },
  { label: getTranslation('resource', 'XML'), value: 'Xml', dbType: 'XML' },
  { label: 'Document', value: 'Document', dbType: 'Document' },
  { label: 'Ocr', value: 'Ocr', dbType: 'Ocr' },
];

const fileFormatOptionInitDtoCommon = {
  headerBeforeRows: 0,
  headerAfterRows: 0,
  headerRows: 1,
  headerJoinDelimiter: ',',
  loadRows: null,
};

export const FILE_DEFAULT_OPTION_INIT_DTO_IMPORT: LibraryFileDtoDefaultType = {
  encoding: 'UTF-8',
  rowsForSchema: 1000,
  sourceFileColumn: false,
};

export const FILE_FORMAT_OPTION_INIT_DTO_IMPORT: {
  [key in LibraryFileFormatKeyType]: LibraryImportPreviewFileDtoType;
} = Object.freeze({
  Delimited: {
    fileFormat: 'Delimited',
    delimited: {
      columnSeparator: ',',
      lineSeparator: '\n',
      storeBlankRows: true,
      treatDelimiter: false,
      parseType: true,
      ...fileFormatOptionInitDtoCommon,
      escape: null,
    },
  },
  Fixed: {
    fileFormat: 'Fixed',
    fixed: {
      lineSeparator: '\n',
      storeBlankRows: true,
      parseType: true,

      sameWidth: true,
      sameColumnWidth: 50,
      numberOfColumns: 10,

      columnWidth: '',

      ...fileFormatOptionInitDtoCommon,
    },
  },
  Excel: {
    fileFormat: 'Excel',
    excel: {
      workSheet: '',
      storeBlankRows: true,

      ...fileFormatOptionInitDtoCommon,
    },
  },
  Avro: {
    fileFormat: 'Avro',
    avro: {},
  },
  Json: {
    fileFormat: 'Json',
    json: {
      columnNaming: 'Simple',
      path: null,
      storeBlankRows: true,
      parseType: true,

      startAfterRows: 0,
      loadRows: null,

      attributePrefix: '@', // Json에서는 사용하지 않음
      elementPrefix: '/',
    },
  },
  Xml: {
    fileFormat: 'Xml',
    xml: {
      columnNaming: 'Simple',
      path: null,
      storeBlankRows: true,
      parseType: true,

      startAfterRows: 0,
      loadRows: null,

      attributePrefix: '@',
      elementPrefix: '/',
    },
  },
  Document: {
    fileFormat: 'Document',
    document: {},
  },
  Ocr: {
    fileFormat: 'Ocr',
    ocr: {},
  },
});

export const FILE_FORMAT_OPTION_INIT_DTO_EXPORT: {
  [key in LibraryFileFormatKeySmallType]: LibraryExportFileDtoType[key];
} = {
  delimited: {
    columnSeparator: ',',
    lineSeparator: '\n',
    header: true,
    quotes: true,
    byteMark: false,
  },
  fixed: {
    lineSeparator: '\n',
    header: true,
    byteMark: false,
    sameWidth: false,
    columnWidth: '',
  },
  excel: {},
  avro: {},
  document: {},
  ocr: {},
  json: {
    byteMark: false,
  },
  xml: {
    byteMark: false,
  },
};

export const COLUMN_NAME_RESERVED_WORDS: string[] = [
  // Common reserved words across MySQL, PostgreSQL, and SQL Server
  // "SELECT",
  // "INSERT",
  // "UPDATE",
  // "DELETE",
  // "ORDER",
  // "GROUP",
  // "FROM",
  // "WHERE",
  // "TABLE",
  // "LIMIT",
  // "OFFSET",
  // "USER",
  // "PASSWORD",
  // "INDEX",
  // "VIEW",
  // "PRIMARY",
  // "KEY",
  // "FOREIGN",
  // "JOIN",
  // "INNER",
  // "OUTER",
  // "LEFT",
  // "RIGHT",
  // "FULL",
  // "CROSS",
  // "UNION",
  // "DISTINCT",
  // "NULL",
];

export const CHAR_ENCODING_TYPE_LIST: Array<string> = [
  'Big5',
  'Big5-HKSCS',
  'CESU-8',
  'EUC-JP',
  'EUC-KR',
  'GB18030',
  'GB2312',
  'GBK',
  'IBM-Thai',
  'IBM00858',
  'IBM01140',
  'IBM01141',
  'IBM01142',
  'IBM01143',
  'IBM01144',
  'IBM01145',
  'IBM01146',
  'IBM01147',
  'IBM01148',
  'IBM01149',
  'IBM037',
  'IBM1026',
  'IBM1047',
  'IBM273',
  'IBM277',
  'IBM278',
  'IBM280',
  'IBM284',
  'IBM285',
  'IBM290',
  'IBM297',
  'IBM420',
  'IBM424',
  'IBM437',
  'IBM500',
  'IBM775',
  'IBM850',
  'IBM852',
  'IBM855',
  'IBM857',
  'IBM860',
  'IBM861',
  'IBM862',
  'IBM863',
  'IBM864',
  'IBM865',
  'IBM866',
  'IBM868',
  'IBM869',
  'IBM870',
  'IBM871',
  'IBM918',
  'ISO-2022-CN',
  'ISO-2022-JP',
  'ISO-2022-JP-2',
  'ISO-2022-KR',
  'ISO-8859-1',
  'ISO-8859-13',
  'ISO-8859-15',
  'ISO-8859-2',
  'ISO-8859-3',
  'ISO-8859-4',
  'ISO-8859-5',
  'ISO-8859-6',
  'ISO-8859-7',
  'ISO-8859-8',
  'ISO-8859-9',
  'JIS-X0201',
  'JIS-X0212-1990',
  'KOI8-R',
  'KOI8-U',
  'Shift-JIS',
  'TIS-620',
  'US-ASCII',
  'UTF-8',
  'UTF-16',
  'UTF-16BE',
  'UTF-16LE',
  'UTF-32',
  'UTF-32BE',
  'UTF-32LE',
  'windows-1250',
  'windows-1251',
  'windows-1252',
  'windows-1253',
  'windows-1254',
  'windows-1255',
  'windows-1256',
  'windows-1257',
  'windows-1258',
  'windows-31j',
  'x-Big5-HKSCS-2001',
  'x-Big5-Solaris',
  'x-COMPOUND-TEXT',
  'x-euc-jp-linux',
  'x-EUC-TW',
  'x-eucJP-Open',
  'x-IBM1006',
  'x-IBM1025',
  'x-IBM1046',
  'x-IBM1097',
  'x-IBM1098',
  'x-IBM1112',
  'x-IBM1122',
  'x-IBM1123',
  'x-IBM1124',
  'x-IBM1166',
  'x-IBM1364',
  'x-IBM1381',
  'x-IBM1383',
  'x-IBM300',
  'x-IBM33722',
  'x-IBM737',
  'x-IBM833',
  'x-IBM834',
  'x-IBM856',
  'x-IBM874',
  'x-IBM875',
  'x-IBM921',
  'x-IBM922',
  'x-IBM930',
  'x-IBM933',
  'x-IBM935',
  'x-IBM937',
  'x-IBM939',
  'x-IBM942',
  'x-IBM942C',
  'x-IBM943',
  'x-IBM943C',
  'x-IBM948',
  'x-IBM949',
  'x-IBM949C',
  'x-IBM950',
  'x-IBM964',
  'x-IBM970',
  'x-ISCII91',
  'x-ISO-2022-CN-CNS',
  'x-ISO-2022-CN-GB',
  'x-iso-8859-11',
  'x-JIS0208',
  'x-JISAutoDetect',
  'x-Johab',
  'x-MacArabic',
  'x-MacCentralEurope',
  'x-MacCroatian',
  'x-MacCyrillic',
  'x-MacDingbat',
  'x-MacGreek',
  'x-MacHebrew',
  'x-MacIceland',
  'x-MacRoman',
  'x-MacRomania',
  'x-MacSymbol',
  'x-MacThai',
  'x-MacTurkish',
  'x-MacUkraine',
  'x-MS932-0213',
  'x-MS950-HKSCS',
  'x-MS950-HKSCS-XP',
  'x-mswin-936',
  'x-PCK',
  'x-SJIS-0213',
  'x-UTF-16LE-BOM',
  'X-UTF-32BE-BOM',
  'X-UTF-32LE-BOM',
  'x-windows-50220',
  'x-windows-50221',
  'x-windows-874',
  'x-windows-949',
  'x-windows-950',
  'x-windows-iso2022jp',
];

export const CONNECTOR_OPTION_TYPE_LIST: DropdownConnectorType[] = [
  {
    get label() {
      return getTranslation('resource', 'JDBC');
    },
    value: 'Jdbc',
  },
  {
    get label() {
      return getTranslation('resource', 'SFTP');
    },
    value: 'Sftp',
  },
];

export const JDBC_VISIBILITY_TYPE_LIST: ConnectorVisibleOptionType[] = [
  {
    get label() {
      return getTranslation('resource', 'HIDE');
    },
    value: 'HIDE',
  },
  {
    get label() {
      return getTranslation('resource', 'SHOW_ALL');
    },
    value: 'ALL',
  },
  {
    get label() {
      return getTranslation('resource', 'SHOW_ONLY');
    },
    value: 'ONLY',
  },
];

export const JDBC_TRUE_FALSE_TYPE_LIST: ConnectorBooleanOptionType[] = [
  {
    get label() {
      return getTranslation('resource', 'TRUE');
    },
    value: true,
  },
  {
    get label() {
      return getTranslation('resource', 'FALSE');
    },
    value: false,
  },
];

export const JDBC_ABLE_TYPE_LIST: ConnectorAbleOptionType[] = [
  {
    get label() {
      return getTranslation('resource', 'DISABLED');
    },
    value: false,
  },
  {
    get label() {
      return getTranslation('resource', 'ENABLED');
    },
    value: true,
  },
];

export const SFTP_EXPORT_OPERATION_TYPE_LIST: DropDownListOptionType[] = [
  {
    get label() {
      return getTranslation('resource', 'NORMAL_OPERATION');
    },
    value: 'NORMAL_OPERATION',
  },
  {
    get label() {
      return getTranslation('resource', 'PUT_OPERATION');
    },
    value: 'PUT_OPERATION',
  },
];

export const SFTP_AUTHENTICATION_TYPE_LIST: DropDownListOptionType[] = [
  // {
  //   label: "SSH Key with Passphrase",
  //   value: "SSH_WITH_PASSPHRASE",
  // },
  // {
  //   label: "SSH Key without Passphrase",
  //   value: "SSH_WITHOUT_PASSPHRASE",
  // },
  {
    get label() {
      return getTranslation('resource', 'USER_CREDENTIALS');
    },
    value: 'USER_CREDENTIALS',
  },
];

export const CLEAR_UP_OPTION_LIST = [
  {
    get label() {
      return getTranslation('resource', 'DELETE_OLDER_VER');
    },
    value: 'older',
  },
  {
    get label() {
      return getTranslation('resource', 'DELETE_VER_BY_DATE');
    },
    value: 'date',
  },
  {
    get label() {
      return getTranslation('resource', 'DELETE_ALL_VER');
    },
    value: 'all',
  },
];

// dataset 상태 검색 조건 option list
export const DATASET_STATUS_OPTION = [
  {
    get label() {
      return getTranslation('resource', 'COMPLETE');
    },
    value: 'COMPLETE',
  },
  {
    get label() {
      return getTranslation('resource', 'RUNNING');
    },
    value: 'RUNNING',
  },
  {
    get label() {
      return getTranslation('resource', 'FAILED');
    },
    value: 'FAILED',
  },
];

export const FAKE_OPTION_LIST: DropDownListOptionType[] = [
  {
    label: 'JDBC',
    value: 'jdbc',
  },
  {
    label: 'hangmok2',
    value: '항목2',
  },
  {
    label: 'hangmok3',
    value: '항목3',
  },
  {
    label: 'hangmok4',
    value: '항목4',
  },
  {
    label: 'hangmok5',
    value: '항목5',
  },
  {
    label: 'hangmok6',
    value: '항목6',
  },
  {
    label: 'hangmok7',
    value: '항목7',
  },
  {
    label: 'hangmok8',
    value: '항목8',
  },
  {
    label: 'hangmok9',
    value: '항목9',
  },
  {
    label: 'hangmok10',
    value: '항목10',
  },
  {
    label: 'hangmok11',
    value: '항목11',
  },
  {
    label: 'hangmok12',
    value: '항목12',
  },
  {
    label: 'hangmok13',
    value: '항목13',
  },
];

export const INIT_CONNECTOR_JDBC_OPTION_INFO: ConnectorJdbcOptionInfoType = {
  connectorType: CONNECTOR_OPTION_TYPE_LIST[0].value as Extract<ConnectorValueType, 'Jdbc'>,

  connectorName: null,
  connectorDescription: null,

  assignedGroups: [],

  accessDetailBtns: { accessUpdate: false, accessPermission: false },

  connectorJdbcDto: {
    jdbcUrl: null,

    dbType: 'Mysql',

    databaseVisibility: null,
    schemaVisibility: null,
    tableVisibility: null,

    queryPrefetchSize: 10000,
    maxColumnSize: 32767,
    countQueryYn: null,

    preImportSql: null,
    postImportSql: null,

    exportBatchSize: 10000,
    maxVarcharSize: 4000,
    autoCreateTableYn: null,

    preExportSql: null,
    postExportSql: null,

    username: null,
    password: null,
  },
};

export const INIT_CONNECTOR_SFTP_OPTION_INFO: ConnectorSftpOptionInfoType = {
  connectorType: CONNECTOR_OPTION_TYPE_LIST[1].value as Extract<ConnectorValueType, 'Sftp'>,

  connectorName: null,
  connectorDescription: null,

  assignedGroups: [],

  accessDetailBtns: { accessUpdate: false, accessPermission: false },

  connectorSftpDto: {
    sftpHost: null,
    sftpPort: 22,

    automaticHostKeyVerificationYn: false,
    keepAliveYn: true,
    dataCompression: true,

    socketTimeoutSeconds: null,
    rootDirectory: null,
    exportOption: null,
    sftpAuthenticationType: 'USER_CREDENTIALS',

    sftpUsername: null,
    sshPrivateKey: null,
    sftpPassword: null,
    passphrase: null,
  },
};

export const INIT_DATASOURCE_SFTP_OPTION_INFO: DatasourceSftpOptionInfoType = {
  connectorType: CONNECTOR_OPTION_TYPE_LIST[1].value as Extract<ConnectorValueType, 'Sftp'>,
  connectorId: null,

  datasourceName: null,
  datasourceDescription: null,

  assignedGroups: [],
  accessDetailBtns: { accessUpdate: false, accessPermission: false },

  datasourceSftpDto: {
    sftpHostYn: null,
    sftpHost: null,

    sftpPortYn: null,
    sftpPort: 22,

    automaticHostKeyVerificationYn: false,

    socketTimeoutSeconds: null,

    rootDirectoryYn: null,
    rootDirectory: null,

    exportOptionYn: null,
    exportOption: null,

    sftpAuthenticationTypeYn: null,
    sftpAuthenticationType: null,

    sftpUsername: null,
    sftpPassword: null,
    sshPrivateKey: null,
    passphrase: null,
  },
  datasourceVariableList: null,
};

export const INIT_DATASOURCE_JDBC_OPTION_INFO: DatasourceJdbcOptionInfoType = {
  connectorType: CONNECTOR_OPTION_TYPE_LIST[0].value as Extract<ConnectorValueType, 'Jdbc'>,
  connectorId: null,

  datasourceName: null,
  datasourceDescription: null,

  assignedGroups: [],
  accessDetailBtns: { accessUpdate: false, accessPermission: false },

  datasourceJdbcDto: {
    jdbcUrlYn: null,
    jdbcUrl: null,

    databaseVisibilityYn: null,
    schemaVisibilityYn: null,
    tableVisibilityYn: null,

    databaseVisibility: 'ALL',
    databaseList: null,
    schemaVisibility: 'ALL',
    schemaList: null,
    tableVisibility: 'ALL',
    tableList: null,

    queryPrefetchSizeYn: null,
    maxColumnSizeYn: null,
    maxVarcharSizeYn: null,
    exportBatchSizeYn: null,

    preImportSql: null,
    postImportSql: null,
    preExportSql: null,
    postExportSql: null,

    username: null,
    password: null,
    //dbRole: null;
    autoCreateTableYn: null,
    countQueryYnYn: null,

    dbType: null,

    queryPrefetchSize: 10000,
    maxColumnSize: 32767,
    exportBatchSize: 10000,
    maxVarcharSize: 4000,

    countQueryYn: true,
  },
  datasourceVariableList: null,
};

export const DATASET_COLORSET: ThemeColorType[] = [
  '--unique-1',
  '--unique-2',
  '--unique-3',
  '--unique-4',
  '--unique-5',
  '--unique-6',
  '--unique-7',
  '--unique-8',
  '--unique-9',
  '--unique-10',
  '--unique-11',
  '--unique-12',
  '--unique-13',
  '--unique-14',
  '--unique-15',
  '--unique-16',
  '--unique-17',
  '--unique-18',
  '--unique-19',
  '--unique-20',
  '--unique-21',
  '--unique-22',
  '--unique-23',
  '--unique-24',
  '--unique-25',
  '--unique-26',
  '--unique-27',
  '--unique-28',
  '--unique-29',
  '--unique-30',
  '--unique-31',
  '--unique-32',
  '--unique-33',
  '--unique-34',
  '--unique-35',
  '--unique-36',
  '--unique-37',
  '--unique-38',
  '--unique-39',
  '--unique-40',
  '--unique-41',
  '--unique-42',
  '--unique-43',
  '--unique-44',
  '--unique-45',
  '--unique-46',
  '--unique-47',
  '--unique-48',
  '--unique-49',
  '--unique-50',
  '--unique-51',
  '--unique-52',
  '--unique-53',
  '--unique-54',
  '--unique-55',
  '--unique-56',
  '--unique-57',
  '--unique-58',
  '--unique-59',
  '--unique-60',
  '--unique-61',
  '--unique-62',
  '--unique-63',
  '--unique-64',
  '--unique-65',
  '--unique-66',
  '--unique-67',
  '--unique-68',
  '--unique-69',
  '--unique-70',
  '--unique-71',
  '--unique-72',
  '--unique-73',
  '--unique-74',
  '--unique-75',
  '--unique-76',
  '--unique-77',
  '--unique-78',
  '--unique-79',
  '--unique-80',
  '--unique-81',
  '--unique-82',
  '--unique-83',
  '--unique-84',
  '--unique-85',
  '--unique-86',
  '--unique-87',
  '--unique-88',
  '--unique-89',
  '--unique-90',
  '--unique-91',
  '--unique-92',
  '--unique-93',
  '--unique-94',
  '--unique-95',
  '--unique-96',
  '--unique-97',
  '--unique-98',
  '--unique-99',
  '--unique-100',
];

// apf 검색 조건 option list
export const PROJECT_FLOW_RUN_STATE = [
  {
    get label() {
      return getTranslation('resource', 'ALL');
    },
    value: 'NEW',
  },
  {
    get label() {
      return getTranslation('resource', 'COMPLETED');
    },
    value: 'COMPLETE',
  },
  {
    get label() {
      return getTranslation('resource', 'RUNNING');
    },
    value: 'RUNNING',
  },
  {
    get label() {
      return getTranslation('resource', 'WAITING');
    },
    value: 'WAITING',
  },
  {
    get label() {
      return getTranslation('resource', 'FAILED');
    },
    value: 'FAILED',
  },
];

export const PROJECT_FLOW_STATUS = [
  {
    get label() {
      return getTranslation('resource', 'ALL');
    },
    value: 'ALL',
  },
  {
    get label() {
      return getTranslation('resource', 'ENABLED');
    },
    value: 'false',
  },
  {
    get label() {
      return getTranslation('resource', 'DISABLED');
    },
    value: 'true',
  },
];

// apf group 검색 조건 option list
export const PROJECT_FLOW_TYPE_SEARCH_LIST = [
  {
    get label() {
      return getTranslation('resource', 'ALL');
    },
    value: 'ALL',
  },
  {
    get label() {
      return getTranslation('resource', 'GROUP');
    },
    value: 'GROUP',
  },
  {
    get label() {
      return getTranslation('resource', 'UNGROUPED');
    },
    value: 'NON_GROUP',
  },
];

// apf option 팝업 탭 리스트
export const RUN_TAB_LIST = [
  {
    get title() {
      return getTranslation('resource', 'GENERAL');
    },
    id: 1,
  },
  {
    get title() {
      return getTranslation('resource', 'INPUTS');
    },
    id: 2,
  },
  {
    get title() {
      return getTranslation('resource', 'OUTPUTS');
    },
    id: 3,
  },
  {
    get title() {
      return getTranslation('resource', 'RUN_DETAILS');
    },
    id: 4,
  },
];

// apf group option 팝업 탭 리스트
export const GROUP_RUN_TAB_LIST = [
  {
    get title() {
      return getTranslation('resource', 'GENERAL');
    },
    id: 1,
  },
  {
    get title() {
      return getTranslation('resource', 'FLOWS');
    },
    id: 5,
  },
  {
    get title() {
      return getTranslation('resource', 'RUN_DETAILS');
    },
    id: 4,
  },
];

export const ROW_PER_PAGE = 30;

export const APF_ROW_PER_PAGE = 15;

export const NODE_STYLES = [
  {}, // 기본 노드 스타일
  { opacity: '0.4' }, // hover된 노드와 연결되지 않은 노드
  { border: '1px solid var(--accent-navy)' }, // hover된 노드
  { border: '1px solid var(--accent-plum)' }, // hover된 노드의 오른쪽으로 연결된 노드
  { border: '1px solid var(--accent-mint)' }, // hover된 노드의 왼쪽으로 연결된 노드
];

export const EDGE_STYLES = [
  '#D0D7DE', // 기본 노드 스타일
  '#d0d7de4a', // hover된 노드와 연결되지 않은 edge
  '#d878e7', // hover된 노드의 오른쪽으로 연결된 edge
  '#59c5be', // hover된 노드의 왼쪽으로 연결된 edge
];

export const COMPARE_EXCLUDE_STEPKEY_LIST = [
  'createdBy',
  'createdDate',
  'lastModifiedBy',
  'lastModifiedDate',
  'stepId',
  'stepErrorMessages',
  'useYn',
  'previewFlag',
  'cacheKey',
  // "annotate",
  'stepColumnInfoList',
  'refreshFlag',
  'projectVersionId',
  'chosen',
  'id',
  'isModified',
];

export const DEFAULT_TOTAL_MAP = {
  totalPages: 0,
  allRows: 0,
  totalRows: 0,
};

export const NONE_FILTER_LIST = [
  'start',
  'editColumn',
  'join',
  'append',
  'lookup',
  'aggregate',
  'shift',
];

export const SORT_LOCK_STEPLIST = ['autoNumber', 'shift', 'rank', 'fill', 'aggregate'];

export const DAY_ORDER: { [key: string]: number } = {
  SUN: 0,
  MON: 1,
  TUE: 2,
  WED: 3,
  THU: 4,
  FRI: 5,
  SAT: 6,
};

export const COMPUTE_FUNCTION_LIST = [
  { label: 'ABS()', value: 'ABS()', component: <ABS /> },
  { label: 'AND()', value: 'AND()', component: <AND /> },
  { label: 'AVERAGE()', value: 'AVERAGE()', component: <AVERAGE /> },
  { label: 'CEILING()', value: 'CEILING()', component: <CEILING /> },
  { label: 'CHAR()', value: 'CHAR()', component: <CHAR /> },
  {
    label: 'CONCATENATE()',
    value: 'CONCATENATE()',
    component: <CONCATENATE />,
  },
  { label: 'DATE()', value: 'DATE()', component: <DATE /> },
  { label: 'DATEADD()', value: 'DATEADD()', component: <DATEADD /> },
  { label: 'DATEDIFF()', value: 'DATEDIFF()', component: <DATEDIFF /> },
  { label: 'DATEFORMAT()', value: 'DATEFORMAT()', component: <DATEFORMAT /> },
  { label: 'DATETRUNC()', value: 'DATETRUNC()', component: <DATETRUNC /> },
  { label: 'DATEVALUE()', value: 'DATEVALUE()', component: <DATEVALUE /> },
  { label: 'DAY()', value: 'DAY()', component: <DAY /> },
  { label: 'DAYOFWEEK()', value: 'DAYOFWEEK()', component: <DAYOFWEEK /> },
  { label: 'DAYOFYEAR()', value: 'DAYOFYEAR()', component: <DAYOFYEAR /> },
  { label: 'ENDOFMONTH()', value: 'ENDOFMONTH()', component: <ENDOFMONTH /> },
  { label: 'EXP()', value: 'EXP()', component: <EXP /> },
  {
    label: 'FACTORIAL()',
    value: 'FACTORIAL()',

    component: <FACTORIAL />,
  },
  { label: 'FIND()', value: 'FIND()', component: <FIND /> },
  {
    label: 'FIRSTNONBLANK()',
    value: 'FIRSTNONBLANK()',

    component: <FIRSTNONBLANK />,
  },
  { label: 'FLOOR()', value: 'FLOOR()', component: <FLOOR /> },
  {
    label: 'FROMUNIXTIME()',
    value: 'FROMUNIXTIME()',

    component: <FROMUNIXTIME />,
  },
  {
    label: 'HASHVALUE()',
    value: 'HASHVALUE()',

    component: <HASHVALUE />,
  },
  { label: 'HOUR()', value: 'HOUR()', component: <HOUR /> },
  { label: 'IF()', value: 'IF()', component: <IF /> },
  { label: 'IFERROR()', value: 'IFERROR()', component: <IFERROR /> },
  { label: 'INT()', value: 'INT()', component: <INT /> },
  { label: 'ISBLANK()', value: 'ISBLANK()', component: <ISBLANK /> },
  { label: 'ISDATE()', value: 'ISDATE()', component: <ISDATE /> },
  { label: 'ISNULL()', value: 'ISNULL()', component: <ISNULL /> },
  { label: 'ISNUMBER()', value: 'ISNUMBER()', component: <ISNUMBER /> },
  { label: 'ISTEXT()', value: 'ISTEXT()', component: <ISTEXT /> },
  { label: 'LEFT()', value: 'LEFT()', component: <LEFT /> },
  { label: 'LEN()', value: 'LEN()', component: <LEN /> },
  { label: 'LN()', value: 'LN()', component: <LN /> },
  { label: 'LOG()', value: 'LOG()', component: <LOG /> },
  { label: 'LOG10()', value: 'LOG10()', component: <LOG10 /> },
  { label: 'LOWER()', value: 'LOWER()', component: <LOWER /> },
  { label: 'MAX()', value: 'MAX()', component: <MAX /> },
  {
    label: 'MAXDATE()',
    value: 'MAXDATE()',

    component: <MAXDATE />,
  },
  {
    label: 'MEDIAN()',
    value: 'MEDIAN()',

    component: <MEDIAN />,
  },
  { label: 'MID()', value: 'MID()', component: <MID /> },
  { label: 'MIDNIGHT()', value: 'MIDNIGHT()', component: <MIDNIGHT /> },
  { label: 'MIN()', value: 'MIN()', component: <MIN /> },
  { label: 'MINDATE()', value: 'MINDATE()', component: <MINDATE /> },
  { label: 'MINUTE()', value: 'MINUTE()', component: <MINUTE /> },
  { label: 'MOD()', value: 'MOD()', component: <MOD /> },
  { label: 'MODE()', value: 'MODE()', component: <MODE /> },
  { label: 'MONTH()', value: 'MONTH()', component: <MONTH /> },
  {
    label: 'NETWORKDAYS()',
    value: 'NETWORKDAYS()',

    component: <NETWORKDAYS />,
  },
  { label: 'NOT()', value: 'NOT()', component: <NOT /> },
  { label: 'NOW()', value: 'NOW()', component: <NOW /> },
  { label: 'OR()', value: 'OR()', component: <OR /> },
  { label: 'PADLEFT()', value: 'PADLEFT()', component: <PADLEFT /> },
  { label: 'PADRIGHT()', value: 'PADRIGHT()', component: <PADRIGHT /> },
  { label: 'POWER()', value: 'POWER()', component: <POWER /> },
  { label: 'QUARTER()', value: 'QUARTER()', component: <QUARTER /> },
  { label: 'REGEXP()', value: 'REGEXP()', component: <REGEXP /> },
  { label: 'REGEXPEXTRACT()', value: 'REGEXPEXTRACT()', component: null },
  { label: 'REGEXPREPLACE()', value: 'REGEXPREPLACE()', component: null },
  { label: 'REPEAT()', value: 'REPEAT()', component: <REPEAT /> },
  { label: 'REPLACE()', value: 'REPLACE()', component: <REPLACE /> },
  { label: 'REVERSE()', value: 'REVERSE()', component: <REVERSE /> },
  { label: 'RIGHT()', value: 'RIGHT()', component: <RIGHT /> },
  { label: 'ROUND()', value: 'ROUND()', component: <ROUND /> },
  { label: 'ROUNDDOWN()', value: 'ROUNDDOWN()', component: <ROUNDDOWN /> },
  {
    label: 'ROUNDPERC()',
    value: 'ROUNDPERC()',
    component: <ROUNDPERC />,
  },
  { label: 'SEARCH()', value: 'SEARCH()', component: <SEARCH /> },
  { label: 'SECOND()', value: 'SECOND()', component: <SECOND /> },
  {
    label: 'SETTIMEZONE()',
    value: 'SETTIMEZONE()',

    component: <SETTIMEZONE />,
  },
  { label: 'SIGN()', value: 'SIGN()', component: <SIGN /> },
  { label: 'SQRT()', value: 'SQRT()', component: <SQRT /> },
  { label: 'STDEV()', value: 'STDEV()', component: <STDEV /> },
  {
    label: 'STDEVP()',
    value: 'STDEVP()',

    component: <STDEVP />,
  },
  { label: 'STR()', value: 'STR()', component: <STR /> },
  {
    label: 'SUBSTITUTE()',
    value: 'SUBSTITUTE()',

    component: <SUBSTITUTE />,
  },
  { label: 'SUM()', value: 'SUM()', component: <SUM /> },
  { label: 'TODAY()', value: 'TODAY()', component: <TODAY /> },
  { label: 'TRIM()', value: 'TRIM()', component: <TRIM /> },
  { label: 'TRIMLEFT()', value: 'TRIMLEFT()', component: <TRIMLEFT /> },
  { label: 'TRIMRIGHT()', value: 'TRIMRIGHT()', component: <TRIMRIGHT /> },
  { label: 'UPPER()', value: 'UPPER()', component: <UPPER /> },
  { label: 'VALUE()', value: 'VALUE()', component: <VALUE /> },
  { label: 'VAR()', value: 'VAR()', component: <VAR /> },
  { label: 'VARP()', value: 'VARP()', component: <VARP /> },
  { label: 'WEEKOFYEAR()', value: 'WEEKOFYEAR()', component: <WEEKOFYEAR /> },
  {
    label: 'WORKDAY()',
    value: 'WORKDAY()',

    component: <WORKDAY />,
  },
  { label: 'YEAR()', value: 'YEAR()', component: <YEAR /> },
];

export const COLOR_LIST = [
  ['#ffffff', '#f6f6f6', '#dedede', '#919191', '#6c6c6c', '#2d2d2d', '#141414', '#000000'],
  ['#FFEFEB', '#FFC6B8', '#FFA38D', '#FF543C', '#FF0011', '#B10000', '#650004', '#330002'],
  ['#FFFAF5', '#FFDFC1', '#FFCB9A', '#FF9F46', '#FF8800', '#AF5200', '#773700', '#421F00'],
  ['#FFFDE5', '#FFF8B2', '#FFF388', '#FFED2E', '#FFCD00', '#A28F00', '#5F5400', '#2E2900'],
  ['#F7FFF0', '#DFFDC1', '#B1DA8D', '#8DCD61', '#4AAF00', '#2F7A1C', '#215113', '#11290A'],
  ['#E7FDFD', '#B5FAF9', '#15CAC3', '#00B7AC', '#009286', '#006A5F', '#004B43', '#001A17'],
  ['#DBF8FF', '#A7EFFF', '#24DDFF', '#00C6FF', '#00AAF0', '#006F9C', '#00455F', '#00212E'],
  ['#C2E6FF', '#90D1FF', '#51B1FF', '#007FE6', '#0062C4', '#003F77', '#002D55', '#001324'],
  ['#FEEBFA', '#FCBAEF', '#C680B8', '#B456A1', '#A01D86', '#690055', '#460039', '#140011'],
  ['#FFE0EC', '#FFC2D9', '#FFA3C7', '#FF85B8', '#FF5A9E', '#FF0081', '#780039', '#470022'],
];

export const COLOR_THEME = {
  dark: [
    ['#E5E5E6', '#CBCBCD', '#97979B', '#4B4B4E', '#020203'],
    ['#FFD4D1', '#FF968F', '#F94F44', '#9D072B', '#380000'],
    ['#FDF287', '#FFCF33', '#FB9723', '#8B480E', '#2E1300'],
    ['#D1FCA6', '#8FE899', '#3CBC96', '#006970', '#001F1F'],
    ['#C5F2FB', '#82DCF7', '#67B3FF', '#004699', '#001429'],
    ['#E0CDEA', '#BFA0D5', '#A56FF6', '#4A12BA', '#18072C'],
    ['#FED8F8', '#FFA3E0 ', '#F84FA4', '#AD0058', '#3D001F'],
  ],
  light: [
    ['#898FA9', '#9765A0', '#F5DD8C', '#7A91F3', '#CB72E4'],
    ['#F08890', '#B73971', '#4BD2A9', '#A7A48B', '#3491D4'],
    ['#628050', '#D99B68', '#D4BBA7', '#D66046', '#7A5245'],
    ['#121B64', '#C8CACA', '#FF996D', '#91E9E9', '#E8E3B0'],
    ['#F6D0F9', '#91E9D3', '#B5AEFD', '#72C2FC', '#6C77D8'],
    ['#C9EF3C', '#FF8073', '#5299FF', '#F5DE62', '#66D483'],
    ['#D96ABA', '#F29F05', '#F97224', '#97BF04', '#BB0000'],
  ],
};

export const SORTABLE_OPTIONS = {
  animation: 100,
  swapThreshold: 0.65,
  handle: '.drag-handle',
};

export const ANCHOR_OPTION = {
  stroke: '#218BFF',
  radius: 6, // 바깥 큰 원의 크기
  fillRadialGradientStartPoint: { x: 0, y: 0 },
  fillRadialGradientEndPoint: { x: 0, y: 0 },
  fillRadialGradientStartRadius: 3, // 작은 원 크기
  fillRadialGradientEndRadius: 6, // 큰 원 크기
  fillRadialGradientColorStops: [
    0,
    '#218BFF', // 내부의 작은 원
    0.3,
    '#fff',
    1,
    '#fff', // 바깥쪽 큰 원의 색상
  ],
  draggable: true,
};

export const DOCUMENT_COLUMN_PREFIX = '$$_DOCUMENT_';

export const TREE_KEY_SEP = '\u001F';
